import http from '@/services/http';
import axios from 'axios';
import { error, info } from '@/utils/safetyLog';
import {
  promotionBannerUrlMap,
  popupBannerUrlMap,
  mulPopupBannerUrlMap,
  mulPopupBannerContenttypeUidMap,
} from '@/utils/constants';

const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_BASE_URL;
const defaultLanguage = 'zh-hk';

export const getEntryByContentTypeUrl = async (
  contentType: string,
  url: string,
  includeReference?: any,
  localLanguage: string = defaultLanguage,
) => {
  try {
    const response = await http({}).post(`/contentstack/${contentType}/`, {
      queryObj: { url },
      language: localLanguage,
      includeReference,
    });
    return response;
  } catch (e) {
    error('getEntryByContentTypeUrl error:', e);
    return null;
  }
};

export const getEntryByContentTypeAndEntry = async (
  contentType: string,
  entry: string,
  includeReference?: string[],
) => {
  try {
    const res = http({}).post(`/contentstack/${contentType}/${entry}`, {
      includeReference: includeReference || [],
      defaultLanguage,
    });
    return res;
  } catch (e) {
    error('getEntryByContentTypeAndEntry error:', e);
    return null;
  }
};

export const getPromotionBanner = async (pathname: string, localLanguage: string = defaultLanguage) => {
  try {
    const requestData = {
      language: localLanguage,
      includeReference: [],
      targetUrl: promotionBannerUrlMap[pathname],
    };
    const response = await http({}).post('/banner/shared_banner_modal', requestData);
    return response;
  } catch (e) {
    error('getPromotionBanner error:', e);
    return null;
  }
};

export const getPopupBanner = async (pathname: string, localLanguage: string = defaultLanguage) => {
  try {
    const requestData = {
      language: localLanguage,
      includeReference: [],
      targetUrl: popupBannerUrlMap[pathname],
    };
    const response = await http({}).post('/banner/pop_up_modal', requestData);
    return response;
  } catch (e) {
    error('getPopupBanner error:', e);
    return null;
  }
};

export const getMultiplePopupBanner = async (
  pathname: string,
  localLanguage: string = defaultLanguage,
  articleUrl?: string,
) => {
  try {
    const url = articleUrl ? `/${articleUrl}/` : '';
    const queryObj = url === '/undefined/' ? {} : { url };

    const requestData = {
      queryObj,
      language: localLanguage === 'en-us' ? 'en-us' : defaultLanguage,
      targetUrl: mulPopupBannerUrlMap[pathname],
    };

    const response = await http({}).post(
      `/banner/shared_blog_pop_up_modal/${mulPopupBannerContenttypeUidMap[pathname]}`,
      requestData,
    );
    return response;
  } catch (e) {
    error('getMultiplePopupBanner error:', e);
    return {data:[]};
  }
};

export const getFeatureConfig = async () => {
  try {
    const requestData = {
      language: 'en-us',
      queryObj: {},
    };
    const response = await http({}).post('/contentstack/Feature_Config', requestData);
    return response;
  } catch (e) {
    error('getFeatureConfig error:', e);
    return null;
  }
};

export const getBlogFeatureConfig = async () => {
  try {
    const requestData = {
      language: 'en-us',
      queryObj: {},
    };
    const response = await http({}).post('/contentstack/blog_feature_config/blt6963ea3b5da6c2f7', requestData);
    return response;
  } catch (e) {
    error('getBlogFeatureConfig error:', e);
    return null;
  }
};
